import { render } from "./mapaEspecies.vue?vue&type=template&id=0fdd537d&scoped=true"
const script = {}

import "./mapaEspecies.vue?vue&type=style&index=0&id=0fdd537d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fdd537d"]])

export default __exports__